import { render, staticRenderFns } from "./PrincipalClients.vue?vue&type=template&id=6f6a1f8e&"
import script from "./PrincipalClients.vue?vue&type=script&lang=js&"
export * from "./PrincipalClients.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports